<template>
  <div id="server-page">
    <b-card no-body class="h-100">
      <!-- header component -->
      <b-card-header>
        <!-- title -->
        <b-card-title class="d-flex align-items-center">
          <i class="bi bi-server"></i>
          <span style="margin-left: 5px"> Grafana </span>
        </b-card-title>
        <div
          class="d-flex flex-wrap gap-5px justify-content-end align-items-center"
        >
          <!-- add server button -->
          <b-button variant="outline-info" v-b-modal.modal-add-server>
            <feather-icon icon="PlusIcon" />
            <span>Tambah Server</span>
          </b-button>
          <!-- keyword filter -->
          <b-input-group class="input-group-merge" style="width: 20rem">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              placeholder="Masukkan kata kunci..."
              v-model="filter_data.key"
            />
          </b-input-group>
        </div>
      </b-card-header>
      <div>
        <!-- loader component -->
        <loader v-if="is_loading" />
        <!-- table component -->
        <dataTable
          v-else
          :data="table_data"
          :editItems="editServer"
          :deleteItems="deleteServer"
          :is_pagination="false"
        />
        <paginationInfo
          :page="pagination.page"
          :items="pagination.items"
          :count="pagination.count"
          @update-value="paginationChanged"
        />
      </div>
    </b-card>
    <!-- add user  modal component -->
    <addServer />
    <!-- edit user modal component -->
    <editServer :data="server_data" />
  </div>
</template>
<script>
import useJwt from "@/auth/jwt/useJwt";
import dataTable from "@/views/components/dataTable.vue";
import paginationInfo from "@/views/components/paginationInfo.vue";
import loader from "@/views/components/loader.vue";
import addServer from "@/views/components/grafana/addServer.vue";
import editServer from "@/views/components/grafana/editServer.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BCardBody,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
  VBModal,
} from "bootstrap-vue";

export default {
  name: "Grafana",
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardSubTitle,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    paginationInfo,
    dataTable,
    loader,
    addServer,
    editServer,
  },
  data() {
    return {
      is_loading: true,
      filter_data: {
        key: "",
      },
      pagination: {
        page: 1,
        items: 100,
        count: 0,
      },
      table_data: {
        fields: [
          {
            key: "no",
            label: "no",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "1rem" },
          },
          {
            key: "name",
            label: "nama server",
            sortable: true,
            thClass: "text-left",
            tdClass: "text-left",
            thStyle: { width: "35%" },
          },
          {
            key: "grafana_url",
            label: "url grafana",
            sortable: true,
            thClass: "text-left",
            tdClass: "text-left",
          },
          {
            key: "actions",
            label: "aksi",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "5%", paddingRight: "2rem" },
          },
        ],
        items: [],
      },
      server_data: null,
    };
  },
  created() {
    this.getData();
  },
  watch: {
    "filter_data.key"() {
      if (
        this.filter_data.key.trim().length >= 2 ||
        this.filter_data.key.trim().length == 0
      ) {
        this.getData();
      }
    },
  },
  methods: {
    paginationChanged(data) {
      this.pagination = data;
      this.getData();
    },
    getData() {
      this.is_loading = true;
      let params = {
        ...(this.filter_data.key ? { key: this.filter_data.key } : {}),
        page: this.pagination.page,
        item: this.pagination.items,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api = process.env.VUE_APP_API_URL + "server?" + query;
      useJwt.axiosIns
        .get(api)
        .then((res) => {
          this.table_data.items = res.data.server_data || [];
          this.pagination.count = res.data.pagination_info.count || 0;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    editServer(id) {
      let filter_val = this.table_data.items.filter((el) => el._id == id);
      let user = filter_val[0];
      this.server_data = {
        _id: id,
        name: user.name,
        grafana_url: user.grafana_url,
      };
      this.$bvModal.show("modal-edit-server");
    },
    deleteServer(id, name) {
      this.$swal({
        title: "Apakah Anda Yakin?",
        html: `<strong>${name}</strong> Akan dihapus dari daftar grafana`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Hapus!",
        cancelButtonText: "Batal",
        customClass: {
          confirmButton: "btn btn-info",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let api = process.env.VUE_APP_API_URL + "server/delete/" + id;
          useJwt.axiosIns
            .delete(api)
            .then(() => {
              this.getData();
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Berhasil",
                  icon: "CheckCircleIcon",
                  variant: "success",
                  text: `Data Server berhasil dihapus`,
                },
              });
            })
            .catch((err) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Gagal !",
                  icon: "AlertCircleIcon",
                  variant: "danger",
                  text: `${err.response.data.detail.message ||
                    "Terjadi Kesalahan Pada Sistem!"}`,
                },
              });
            });
        }
      });
    },
  },
  directives: {
    "b-modal": VBModal,
  },
};
</script>
